var _path, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoTesoura01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1234",
    d: "M33.9,10.4c0,0-2-1.7-3.6-0.7c-1.3,0.7-9.3,4.8-12.9,6.6l-5.1-2.9c0.5-1,0.7-2.1,0.3-3.2 c-0.4-1.5-1.5-2.8-2.8-3.5C7.4,5,4.3,5.5,2.7,7.8C2.1,8.8,2,10,2.3,11.1c0.4,1.5,1.5,2.8,2.8,3.5c0.6,0.4,1.3,0.6,2,0.7l0,0h0 c0.1,0,0.1,0,0.2,0c2.6,0.2,5.2,1.1,7.4,2.6c-2.2,1.5-4.7,2.4-7.4,2.6c-0.1,0-0.1,0-0.2,0h0l0,0c-0.7,0.1-1.4,0.4-2,0.7 c-1.4,0.8-2.4,2-2.8,3.5C2,26,2.1,27.2,2.7,28.2c1.6,2.3,4.8,2.9,7.1,1.3c1.4-0.8,2.4-2,2.8-3.5c0.3-1.1,0.2-2.2-0.3-3.2l5.1-2.9 c3.6,1.8,11.7,5.8,12.9,6.6c1.6,0.9,3.6-0.7,3.6-0.7L20.5,18L33.9,10.4z M10.1,12.1c-1,1.1-2.6,1.2-3.7,0.4c-0.8-0.4-1.4-1.2-1.7-2 C4.6,10,4.6,9.5,4.8,9.1C5.8,8,7.4,7.9,8.5,8.7c0.8,0.4,1.4,1.2,1.7,2C10.3,11.2,10.3,11.7,10.1,12.1L10.1,12.1z M10.2,25.3 c-0.3,0.9-0.9,1.6-1.7,2c-1.1,0.9-2.7,0.7-3.7-0.4c-0.2-0.4-0.3-0.9-0.1-1.3c0.3-0.9,0.9-1.6,1.7-2c1.1-0.9,2.7-0.7,3.7,0.4 C10.3,24.3,10.3,24.8,10.2,25.3L10.2,25.3z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_452",
    x: 16.4,
    y: 17.3,
    width: 3.3,
    height: 1.3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_453",
    x: 16.4,
    y: 17.3,
    width: 3.3,
    height: 1.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoTesoura01);
export default __webpack_public_path__ + "static/media/ico-tesoura-01.1f2113b91a9b6c37f97654897be04362.svg";
export { ForwardRef as ReactComponent };